(() => {
  function getCartUI() {
    // Dawn: 通知があれば通知、なければドロワー
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  async function addToCart(variantId, quantity, activeElement) {
    const cartUI = getCartUI();

    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(quantity));

    // ★Dawn標準：sections を要求して、レスポンス内に sections HTML を入れさせる
    if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
      const sectionIds = cartUI.getSectionsToRender().map((s) => s.id);
      formData.append('sections', sectionIds);
      formData.append('sections_url', window.location.pathname);

      if (typeof cartUI.setActiveElement === 'function') {
        cartUI.setActiveElement(activeElement || document.activeElement);
      }
    }

    const url =
      (window.routes && window.routes.cart_add_url)
        ? window.routes.cart_add_url
        : '/cart/add';

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
      },
      body: formData,
    });

    const data = await res.json();

    // Shopifyのエラー形式（在庫切れ等）は status / description が返ることがある
    if (!res.ok || data.status) {
      throw new Error(data.description || data.message || 'カート追加に失敗しました。');
    }

    // ★ここが「挙動を揃える」核心：cart-notification の renderContents を呼ぶ
    if (cartUI && typeof cartUI.renderContents === 'function') {
      cartUI.renderContents(data);
      return;
    }

    // フォールバック：cart UI が無い場合
    // window.location.href = '/cart';
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-card-atc');
    if (!btn) return;

    const wrap = btn.closest('.card-atc');
    if (!wrap) return;

    const variantId = wrap.dataset.variantId;
    const qtyEl = wrap.querySelector('.card-atc__qty'); // selectでもOK
    const quantity = qtyEl ? Math.max(1, parseInt(qtyEl.value || '1', 10)) : 1;

    btn.disabled = true;

    try {
      await addToCart(variantId, quantity, btn);
    } catch (err) {
      alert(err.message);
    } finally {
      btn.disabled = false;
    }
  });
})();